import { HttpEvent, HttpHandler, HttpRequest, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private injector: Injector,
    private authService: AuthService, private tokenExtractor : HttpXsrfTokenExtractor) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let authService = this.injector.get(AuthService);
    let token = authService.getAccessToken()
    let cookieName ='XSRF-TOKEN';
    let headerName='X-XSRF-TOKEN'
    let csrfToken = this.tokenExtractor.getToken();
    request = this.addCred(request);
    if(csrfToken !== null && !request.headers.has(cookieName)){
      request = this.addCsrf(request,headerName,csrfToken)
    }
    if (token) {
      request = this.addToken(request, token)
    }
    return next.handle(request).pipe(
      catchError(errordata => {
        if (errordata.status === 401 && !request.url.includes('refresh') && !request.url.includes('login')) {
          return this.handle401Error(request, next)
        }
        let errMsg = ''
       
          if (errordata.error instanceof ErrorEvent) {
            errMsg = errordata.error.message;
          } else {
            errMsg = `${errordata.status}-${errordata.statusText || ''} ${errordata.error.message}`;
          }
          throw new Error(errMsg);
      })
    )
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((newToken: any) => {
          this.isRefreshing = false;
          this.authService.addAccessToken(newToken.accessToken);
          this.authService.addRefreshToken(newToken.refreshToken);
          this.refreshTokenSubject.next(newToken.accessToken);
          return next.handle(this.addToken(request, newToken.accessToken));
        }),
        catchError((error) => {
          let errMsg = ''
          this.authService.logout(); // or handle other error scenarios
         
          if (error.error instanceof ErrorEvent) {
            errMsg = error.error.message;
          } else {
            errMsg = `${error.status}-${error.statusText || ''} ${error.error.message}`;
          }
          throw new Error(errMsg);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap((token) => {
          return next.handle(this.addToken(request, token));
        })
      );
    }
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
  private addCsrf(request: HttpRequest<any>,CN:string, token: string) {
    return request.clone({
      headers:request.headers.set(CN,token),
    });
  }
  private addCred(request: HttpRequest<any>) {
    return request.clone({
      withCredentials:true
    });
  }
  
}
